<template>
    <v-container fluid>
        <v-btn class="ma-4" color="primary" dark @click="addMap"
            >Add Map
            <v-icon dark right>mdi-plus</v-icon>
        </v-btn>
        <v-btn @click="openAllPanels" class="mr-4">Open All</v-btn>
        <v-btn @click="closeAllPanels" class="mr-4">Close All</v-btn>
        <v-expansion-panels v-model="mapPanel" :multiple="true" :popout="true" :hover="true">
            <draggable
                v-model="imageList"
                class="v-item-group theme--light v-expansion-panels v-expansion-panels--hover v-expansion-panels--popout"
            >
                <v-expansion-panel v-for="item in imageList" :key="item.i"
                v-bind:class="{ 'current-panel': item.id === activePanel }"
                    >
                    <v-expansion-panel-header >
                        <div>
                            <v-icon>mdi-drag</v-icon>
                            <span class="pl-4">{{ item.name }} – {{ item.id }} </span>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content >
                        {{ item.zoom }} ({{ activePanel }}) -- ID: {{ item.id }}
                        <v-btn class="ma-4" color="primary" dark @click="activatePanel(item.id)"
                            >Modify Map
                            <v-icon dark right>mdi-minus-circle</v-icon>
                        </v-btn>

                        <v-btn class="ma-4" color="attention" dark @click="removeMapAt(item.id)"
                            >Remove Map
                            <v-icon dark right>mdi-minus-circle</v-icon>
                        </v-btn>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </draggable>
        </v-expansion-panels>
    </v-container>
</template>

<script>
import draggable from 'vuedraggable';
let imageID = 0;

export default {
    name: 'Draggable',
    display: 'Draggable',
    instruction: 'Drag using the handle icon',
    components: {
        draggable,
    },
    mounted() {
        this.addMap(); // Add first map block
    },
    methods: {
        removeMapAt(idx) {
            this.panelNum--;
            this.imageList.splice(
                this.imageList.findIndex((item) => item.id === idx),
                1
            );
        },
        addMap: function() {
            imageID++;
            this.panelNum++;
            this.imageList.push({
                id: imageID,
                name: 'New Image',
                text: '',
                zoom: 1,
            });
        },
        openAllPanels() {
            this.mapPanel = [...Array(this.panelNum).keys()].map((k, i) => i);
        },
        // Reset the panel
        closeAllPanels() {
            this.mapPanel = [];
        },
        activatePanel(id) {
            console.log(id);
            this.activePanel = id
        },
    },
    data() {
        return {
            activePanel: 0,
            imageList: [],
            mapPanel: [],
            panelNum: 0,
        };
    },
};
</script>
<style scoped>
.button {
    margin-bottom: 35px;
}
.handle {
    float: left;
    padding-top: 8px;
    padding-bottom: 8px;
}
.close {
    float: right;
    padding-top: 8px;
    padding-bottom: 8px;
}
input {
    display: inline-block;
    width: 50%;
}
.text {
    margin: 20px;
}

.current-panel {
    border-top: 2px solid red;
}
</style>
